module.exports = __webpack_public_path__ + "img/pse.cff85b4f.png";